import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default (locations, projectsLabel = 'Проектов') => ({

    init() {

        const map = L.map(this.$el, {
            scrollWheelZoom: false,
            attributionControl: false
        }).setView([48.0, 67.0], 6)

        L.control.attribution({
            position: 'bottomright'
        }).addTo(map)

        map.attributionControl.setPrefix('')

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors'
        }).addTo(map)

        const bounds = []

        const brandIcon = L.divIcon({
            className: '',
            html: `
                <div style="width:28px;height:40px;display:flex;align-items:center;justify-content:center;">
                    <svg viewBox="0 0 24 36" width="28" height="40">
                        <path
                            d="M12 0C6 0 1.5 4.5 1.5 10.5C1.5 18 12 36 12 36C12 36 22.5 18 22.5 10.5C22.5 4.5 18 0 12 0Z"
                            fill="var(--color-bg-accent)"
                        />
                        <circle cx="12" cy="10.5" r="4.5" fill="white"/>
                    </svg>
                </div>
            `,
            iconSize: [28, 40],
            iconAnchor: [14, 40],
            popupAnchor: [0, -32],
        })

        locations.forEach(location => {

            if (!location.projects?.length) return

            bounds.push([location.lat, location.lng])

            const popupContent = `
                <div class="relative bg-bg-primary rounded-2xl shadow-2xl p-4 w-[85vw] max-w-[420px]">

                    <button
                        onclick="this.closest('.leaflet-popup').remove();"
                        class="absolute top-4 right-4 text-lg leading-none transition"
                        style="color: var(--color-text-primary); opacity: .6;"
                        onmouseover="this.style.color='var(--color-bg-accent)'; this.style.opacity='1';"
                        onmouseout="this.style.color='var(--color-text-primary)'; this.style.opacity='.6';"
                    >
                        ×
                    </button>

                    <div class="text-lg font-semibold mb-4"
                         style="color: var(--color-text-primary);">
                        ${location.name}
                    </div>

                    <div class="max-h-[40vh] overflow-y-auto text-sm divide-y divide-border-default">

                        ${location.projects.map((project, index) => `
                            <a
                                href="/portfolio/${project.slug}-${project.id}"
                                class="block px-2 py-2 transition duration-200 rounded"
                                style="
                                    background: ${index % 2 === 0 ? 'var(--color-bg-secondary)' : 'transparent'};
                                    color: var(--color-text-primary);
                                "
                                onmouseover="this.style.color='var(--color-bg-accent)'"
                                onmouseout="this.style.color='var(--color-text-primary)'"
                            >
                                ${project.name}
                            </a>
                        `).join('')}

                    </div>

                    <div class="mt-4 pt-3 border-t text-xs"
                         style="color: var(--color-text-muted); border-color: var(--color-border-default);">
                        ${projectsLabel}: ${location.projects.length}
                    </div>
                </div>
            `

            L.marker([location.lat, location.lng], { icon: brandIcon })
                .addTo(map)
                .bindPopup(popupContent, {
                    closeButton: false,
                    autoPanPadding: [20, 20]
                })
        })

        if (bounds.length) {
            map.fitBounds(bounds, { padding: [60, 60] })
        }
    }
})
